module.exports = __webpack_public_path__ + "img/case-bg.36bfaa11.png";